import e from "./DefaultSelectAnchor.module.js";
import { c as t } from "react/compiler-runtime";
import { Button as n } from "@jetbrains/ring-ui-built/components/button/button";
import r from "classnames";
import { jsx as i } from "react/jsx-runtime";
//#region src/components/DefaultSelectAnchor/DefaultSelectAnchor.tsx
var a = (a) => {
	let o = t(12), s, c, l, u;
	o[0] === a ? (s = o[1], c = o[2], l = o[3], u = o[4]) : ({children: c, isPopupOpen: u, className: l, ...s} = a, o[0] = a, o[1] = s, o[2] = c, o[3] = l, o[4] = u);
	let d;
	o[5] !== l || o[6] !== u ? (d = r(e.button, l, { [e.activeButton]: u }), o[5] = l, o[6] = u, o[7] = d) : d = o[7];
	let f;
	return o[8] !== s || o[9] !== c || o[10] !== d ? (f = /* @__PURE__ */ i(n, {
		...s,
		className: d,
		dropdown: !0,
		children: c
	}), o[8] = s, o[9] = c, o[10] = d, o[11] = f) : f = o[11], f;
};
//#endregion
export { a as DefaultSelectAnchor };
